import React from 'react';

const MailIcon = () => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g>
				<path d='M2.08317 4.4987C2.49984 3.7487 3.33317 3.33203 4.1665 3.33203C7.08317 3.33203 12.9165 3.33203 15.8332 3.33203C16.6665 3.33203 17.4998 3.7487 17.9165 4.4987C17.9165 4.4987 12.3332 8.4987 10.4165 9.91537C10.1665 10.082 9.74984 10.082 9.4165 9.91537C7.58317 8.4987 2.08317 4.4987 2.08317 4.4987ZM11.4998 11.2487C10.6665 11.9154 9.4165 11.9154 8.58317 11.2487C6.83317 9.9987 1.6665 6.2487 1.6665 6.2487C1.6665 6.2487 1.6665 12.1654 1.6665 14.1654C1.6665 15.582 2.74984 16.6654 4.1665 16.6654C7.08317 16.6654 12.9165 16.6654 15.8332 16.6654C17.2498 16.6654 18.3332 15.582 18.3332 14.1654C18.3332 12.1654 18.3332 6.2487 18.3332 6.2487C18.3332 6.2487 13.1665 9.9987 11.4998 11.2487Z' />
			</g>
		</svg>
	);
};

export default MailIcon;
